import $ from 'jquery';

$.fn.showSpinner = function showSpinner() {
  this.each(function eachSpinner() {
    const $this = $(this);

    if ($this.find('.spinner-bg, .svg-circle-spinner, .LoadingSpinner-background').length === 0) {
      const currentCssPosition = $this.css('position');

      if (currentCssPosition !== 'relative' && currentCssPosition !== 'absolute' && currentCssPosition !== 'fixed') {
        $this.css('position', 'relative');
      }

      const spinner = $('#loadingSpinnerTemplate').html();
      $this.append(spinner);
    }
  });

  return this;
};

$.fn.hideSpinner = function hideSpinner() {
  this.each(function eachSpinner() {
    $(this).find('.spinner-bg, .svg-circle-spinner, .LoadingSpinner-background').remove();
    $(this).css('position', 'auto');
  });

  return this;
};
